import { organizationsApi } from './organizationsApi'

export async function fetchOrganizations(params: {
  q?: string
  status?: string
  page?: number
  limit?: number
} = {}) {
  return organizationsApi.list(params)
}

export async function fetchOrganizationById(id) {
  try {
    return await organizationsApi.getById(id)
  } catch (e) {
    if (e.status === 404 || e.code === 'ORG_NOT_FOUND') {
      const err = new Error('Organization not found')
      err.code = 'NOT_FOUND'
      throw err
    }
    throw e
  }
}

export async function createOrganization(payload) {
  return organizationsApi.create(payload)
}

export async function updateOrganization(id, payload) {
  return organizationsApi.update(id, payload)
}

export async function deleteOrganization(id) {
  return organizationsApi.delete(id)
}

export async function resendOwnerLoginDetails(id) {
  return organizationsApi.resendOwnerLoginDetails(id)
}

export async function sendStorefrontWelcome(id) {
  return organizationsApi.sendStorefrontWelcome(id)
}
